import React, { useState, useEffect, useRef } from 'react';
import { 
    Table, 
    Select, 
    DatePicker, 
    Button, 
    Input, 
    Row, 
    Col, 
    Space, 
    message,
    Empty,
    Typography,
    Badge 
} from 'antd';
import { PlusOutlined, MinusOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import AxiosCaller from '../../../authenticatie/AxiosCaller';
import './ControleBestellingScreen.css';
import { openNotificationSuccess, openNotificationError } from '../../../Components/Notification/Notification';
import GetUserInfo from '../../authenticatie/GetUserInfo';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

function ControleBestellingScreen() {
    const { get, post,put } = AxiosCaller();
    const isFirstRender = useRef(true);
     const navigate = useNavigate();

    // State variables
    const [voorstellen, setVoorstellen] = useState([]);
    const [leveranciers, setLeveranciers] = useState([]);
    const [selectedLeverancier, setSelectedLeverancier] = useState(null);
    const [klassen, setKlassen] = useState([]);
    const [users, setUsers] = useState([]);
    const [producten, setProducten] = useState([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [startDatum, setStartDatum] = useState(dayjs());
    const [eindDatum, setEindDatum] = useState(dayjs().add(7, 'day'));
    const [editingRow, setEditingRow] = useState(null);

    // Fetch initial data
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                await Promise.all([
                    fetchLeveranciers(),
                    fetchKlasses(),
                    fetchUsers()
                ]);
            } catch (error) {
                openNotificationError("Fout bij ophalen van de data", error)
            }
        };
        fetchInitialData();
    }, []);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
    
        if (selectedLeverancier) {
           
                fetchBestellijnen(selectedLeverancier);
            
            fetchProductenByLeverancier(selectedLeverancier);
        }
    }, [selectedLeverancier, startDatum, eindDatum]);

    // API Calls
    const fetchLeveranciers = async () => {
        try {
            const response = await get('/Leverancier');
            setLeveranciers(response.data);
        } catch (error) {
            console.error(error)
            openNotificationError("Fout bij ophalen van leveranciers", error)
        }
    };

    const fetchKlasses = async () => {
        try {
            const response = await get('/klas');
            setKlassen(response.data);
        } catch (error) {
            console.error(error)
            openNotificationError("Fout bij ophalen van klassen", error)
        }
    };

    const fetchUsers = async () => {
        try {
            const response = await get('/users/exclude-aanvrager');
            setUsers(response.data);
        } catch (error) {
            console.error(error)
            openNotificationError("Fout bij ophalen van gebruikers", error)
        }
    };

    const fetchBestellijnen = async (selectedLeverancier) => {
        setVoorstellen([]) // Reset to empty array
        if(selectedLeverancier){
          
            let response= null
            try {
                if(startDatum || eindDatum){
                    const data = {
                        startDatum: startDatum.format('YYYY-MM-DD'),
                        eindDatum: eindDatum.format('YYYY-MM-DD'),
                        leverancierId: selectedLeverancier._id,
                    };
                    response = await post('/bestellijn/byleverancierendate', data);
                   
                }else{
                   
                    response= await post('/bestellijn/byleverancier',{leverancierId: selectedLeverancier._id})
                   
                }
               
                setVoorstellen(Array.isArray(response.data) ? response.data : []);
            } catch (error) {
                openNotificationError('Fout bij ophalen van bestllijnen', error)
                console.error(error)
                setVoorstellen([]); // Set to empty array on error
            }
        }
    };


    const fetchProductenByLeverancier = async (leverancier) => {
        try {
            const response = await get(`/Leverancier/ingredients/${leverancier._id}`);
            setProducten(response.data);
        } catch (error) {
            console.error(error)
            openNotificationError("Fout bij ophalen van producten", error)
        }
    };

  

    // Handlers
    const handleLeverancierChange = async (leverancier) => {
        setVoorstellen([]);
        setSelectedLeverancier(leverancier);
        setExpandedRowKeys([]);
    };
    
    const handleAddNewProduct = () => {
      
        const newProduct = selectedLeverancier?.gesplitsteBestelling 
            ? {
                isNew: true,
                product: { naam: '' },
                aantal: 0,
                klas: null,
                leerkracht: null,
                kookDatum: null
            }
            : {
                isNew: true,
                product: { naam: '' },
                totalAantalConverted: 1,
                totalConvertedEenheid: null,
                bestellijnen: []
            };
        const newVoorstellen = [...voorstellen, newProduct];
        setVoorstellen(newVoorstellen);
        setEditingRow(newVoorstellen.length - 1); // Use the new array's length - 1
    };

    const handleSaveNewProduct = (index) => {
        const newProduct = voorstellen[index];
        
        if(selectedLeverancier.gesplitsteBestelling){
            if (!newProduct.product | !newProduct.aantal) {
                openNotificationError("Vul alle verplichte velden in")
                return;
            }
        }else{
            if (!newProduct.product.naam !=""  || !newProduct.totalAantalConverted) {
                openNotificationError("Vul alle verplichte velden in")
                return;
            }
         

           const  nieuweData= {
                product: newProduct.product,
                aantal: newProduct.aantal,
                kookDatum: startDatum,
                leerkracht: GetUserInfo._id,

            }

            SaveNewProduct(nieuweData)

        }
        setEditingRow(null);
        }


        
    

    const SaveNewProduct = async (data) => {
        try{

            await post('/bestellijn/manual', data)
            openNotificationSuccess("Product toegevoegd")
            fetchBestellijnen()

        }catch(error){
            openNotificationError("Fout bij toeveogen van niew product", error)
            console.error(error)
        }


    }

    

    const handleCancelNewProduct = () => {
        setVoorstellen(voorstellen.filter(p => !p.isNew));
        setEditingRow(null);
    };

    const handleBestel = async () => {
        try {
            await sendToBestelGeschiedenis();
            await fetchBestellijnen();
            openNotificationSuccess("Bestelling succesvol geplaatst")
        } catch (error) {
            console.error(error)
            openNotificationError("Fout bij het verwerken van de bestelling", error)
        }
    };

    const sendToBestelGeschiedenis = async () => {
        try {
            await post('/bestellingsGeschiedenis', formatDataToSend());
        } catch (error) {
            throw error;
        }
    };

    const formatDataToSend = () => {
       
        const safeVoorstellen = Array.isArray(voorstellen) ? voorstellen : [];
        
        if (selectedLeverancier.gesplitsteBestelling) {
          
            const bestellijnIds = []
            const producten = []
            
            safeVoorstellen.forEach(voorstel => {
               bestellijnIds.push(voorstel._id)
               producten.push({
                product: voorstel.product._id,
                aantal: voorstel.aantal,
                leerkracht: voorstel.leerkracht._id,
                klas: voorstel.klas._id,
                datum: voorstel.kookDatum

               })
            });

            
            return {
                leverancierId: selectedLeverancier._id,
                bestellijnIds: bestellijnIds,
                products: producten

                
            };
        } else {
           /*
           {
  "leverancierId": "leverancierId",
  "products": [
    {
      "product": "productId",
      "aantal": "aantal",
    }
  ],
  "bestellijnIds": ["bestellijnId"]
}
   */
            const bestellijnIds = []
            const producten =[]
            safeVoorstellen.forEach(voorstel => {

                    // Ensure bestellijnen is an array before iterating
                    const bestellijnen = Array.isArray(voorstel.bestellijnen) ? voorstel.bestellijnen : [];
                    bestellijnen.forEach(bestelijn => {
                        bestellijnIds.push(bestelijn._id)
                    })

                    producten.push({
                        product: voorstel.product._id,
                        aantal: voorstel.totalAantalConverted
                    })
                }
            );

            return {
                leverancierId: selectedLeverancier._id,
                products: producten,
                bestellijnIds: bestellijnIds
               
            };
        }
    };

    const getColumns = () => {
        const baseColumns = [
            {
                title: 'Product',
                dataIndex: ['product', 'naam'],
                key: 'product',
                render: (text, record, index) => {
                    if (editingRow === index) {
                        return (
                            <Select 
                                style={{ width: '100%' }}
                                placeholder="Selecteer product"
                                value={record.product?._id}
                                onChange={(value) => {
                                    const selectedProduct = producten.find(p => p._id === value);
                                    const updatedVoorstellen = [...voorstellen];
                                    updatedVoorstellen[index] = {
                                        ...updatedVoorstellen[index],
                                        product: selectedProduct,
                                        // Initialize andere velden voor niet-gesplitste leveranciers
                                        totalAantalConverted: 1,
                                        totalConvertedEenheid: selectedProduct.omzetting,
                                        bestellijnen: []
                                    };
                                    setVoorstellen(updatedVoorstellen);
                                }}
                            >
                                {producten.map(product => (
                                    <Option key={product._id} value={product._id}>
                                        {product.naam} {product.omzetting.eenheid.naam}
                                    </Option>
                                ))}
                            </Select>
                        );
                    }
                    return record.product?.naam || 'Geen product';
                }
            },
            {
                title: 'Aantal',
                dataIndex: 'aantal',
                key: 'aantal',
                render: (text, record, index) => {
                    if (editingRow === index) {
                        return (
                            
                            <Input 
                                type="number" 
                                value={
                                    selectedLeverancier?.gesplitsteBestelling 
                                        ? record.aantal 
                                        : record.totalAantalConverted
                                } 
                                onChange={(e) => {
                                    const updatedVoorstellen = [...voorstellen];
                                    if (selectedLeverancier?.gesplitsteBestelling) {
                                        updatedVoorstellen[index].aantal = Number(e.target.value);
                                    } else {
                                        updatedVoorstellen[index].totalAantalConverted = Number(e.target.value);
                                    }
                                    setVoorstellen(updatedVoorstellen);
                                }}
                            />
                        );
                    }
                    if (selectedLeverancier?.gesplitsteBestelling) {
                        return `${record.aantal} ${record.product?.eenheid?.naam}`;
                    } else {
                        return `${record.totalAantalConverted} ${record.totalConvertedEenheid?.naam}`;
                    }
                }
            },
            {
                title: 'Acties',
                key: 'actions',
                render: (text, record, index) => {
                    if (editingRow === index) {
                        return (
                            <Space>
                                <Button 
                                    icon={<SaveOutlined />} 
                                    onClick={() => handleSaveNewProduct(index)}
                                />
                                <Button 
                                    icon={<CloseOutlined />} 
                                    onClick={handleCancelNewProduct}
                                />
                            </Space>
                        );
                    }
                    return (
                        <Space>
                            <Button 
                                icon={<MinusOutlined />} 
                                onClick={() => {
                                    const updatedVoorstellen = voorstellen.map((item, i) => {
                                        if (i === index) {
                                            if (selectedLeverancier?.gesplitsteBestelling) {
                                                return { 
                                                    ...item, 
                                                    aantal: Math.max(0, item.aantal - 1) 
                                                };
                                            } else {
                                                return { 
                                                    ...item, 
                                                    totalAantalConverted: Math.max(0, item.totalAantalConverted - 1) 
                                                };
                                            }
                                        }
                                        return item;
                                    });
                                    setVoorstellen(updatedVoorstellen);
                                }} 
                            />
                            <Button 
                                icon={<PlusOutlined />} 
                                onClick={() => {
                                    const updatedVoorstellen = voorstellen.map((item, i) => {
                                        if (i === index) {
                                            if (selectedLeverancier?.gesplitsteBestelling) {
                                                return { 
                                                    ...item, 
                                                    aantal: (item.aantal || 0) + 1 
                                                };
                                            } else {
                                                return { 
                                                    ...item, 
                                                    totalAantalConverted: (item.totalAantalConverted || 0) + 1 
                                                };
                                            }
                                        }
                                        return item;
                                    });
                                     console.log(updatedVoorstellen)
                                    setVoorstellen(updatedVoorstellen);
                                }} 
                            />
                            <Button 
                               icon={<CloseOutlined/>}                               
                                onClick={() => {
                                    const updatedVoorstellen = voorstellen.map((item, i) => {
                                        if (i === index) {
                                            if (selectedLeverancier?.gesplitsteBestelling) {
                                                return { 
                                                    ...item, 
                                                    aantal: 0 
                                                };
                                            } else {
                                                return { 
                                                    ...item, 
                                                    totalAantalConverted: 0 
                                                };
                                            }
                                        }
                                        return item;
                                    });
                                    console.log(updatedVoorstellen)
                                    setVoorstellen(updatedVoorstellen);
                                }}
                                disabled={
                                    selectedLeverancier?.gesplitsteBestelling 
                                        ? (voorstellen[index]?.aantal || 0) <= 0
                                        : (voorstellen[index]?.totalAantalConverted || 0) <= 0
                                }
                            />
                                
                            
                        </Space>
                    );
                }
            }
        ];
    

        if (selectedLeverancier?.gesplitsteBestelling) {
            const extraColumns = [
                {
                    title: 'Klas',
                    dataIndex: ['klas', 'naam'],
                    key: 'klas',
                    render: (text, record, index) => {
                        if (editingRow === index) {
                            return (
                                <Select 
                                    style={{ width: '100%' }}
                                    placeholder="Selecteer klas"
                                    value={record.klas?._id}
                                    onChange={(value) => {
                                        const selectedKlas = klassen.find(k => k._id === value);
                                        const updatedVoorstellen = [...voorstellen];
                                        updatedVoorstellen[index].klas = selectedKlas;
                                        setVoorstellen(updatedVoorstellen);
                                    }}
                                >
                                    {klassen.map(klas => (
                                        <Option key={klas._id} value={klas._id}>
                                            {klas.naam}
                                        </Option>
                                    ))}
                                </Select>
                            );
                        }
                        return record.klas?.naam || 'Geen klas';
                    }
                },
                {
                    title: 'Leerkracht',
                    dataIndex: ['leerkracht', 'naam'],
                    key: 'leerkracht',
                    render: (text, record, index) => {
                        if (editingRow === index) {
                            return (
                                <Select 
                                    style={{ width: '100%' }}
                                    placeholder="Selecteer leerkracht"
                                    value={record.leerkracht?._id}
                                    onChange={(value) => {
                                        const selectedLeerkracht = users.find(u => u._id === value);
                                        const updatedVoorstellen = [...voorstellen];
                                        updatedVoorstellen[index].leerkracht = selectedLeerkracht;
                                        setVoorstellen(updatedVoorstellen);
                                    }}>
                                    {users.map(user => (
                                        <Option key={user._id} value={user._id}>
                                            {user.naam}
                                        </Option>
                                    ))}
                                </Select>
                            );
                        }
                        return record.leerkracht?.naam || 'Geen leerkracht';
                    }
                },
                {
                    title: 'Datum',
                    dataIndex: 'kookDatum',
                    key: 'datum',
                    render: (text, record, index) => {
                        if (editingRow === index) {
                            return (
                                <DatePicker 
                                    style={{ width: '100%' }}
                                    value={record.kookDatum ? dayjs(record.kookDatum) : null}
                                    onChange={(date) => {
                                        const updatedVoorstellen = [...voorstellen];
                                        updatedVoorstellen[index].kookDatum = date;
                                        setVoorstellen(updatedVoorstellen);
                                    }}
                                    format="DD/MM/YYYY"
                                />
                            );
                        }
                        return record.kookDatum ? dayjs(record.kookDatum).format('DD-MM-YYYY') : 'Geen datum';
                    }
                }
            ];
            
            baseColumns.splice(1, 0, ...extraColumns);
        }

        return baseColumns;
    };

    const renderContent = () => {
        if (!selectedLeverancier) {
            return <div>Selecteer eerst een leverancier</div>;
        }

        // Ensure voorstellen is always an array
        const safeVoorstellen = Array.isArray(voorstellen) ? voorstellen : [];
        
        if (safeVoorstellen.length === 0) {
            return (
                <div style={{ 
                    textAlign: 'center', 
                    padding: '20px', 
                    backgroundColor: '#f0f0f0', 
                    borderRadius: '8px' 
                }}>
                    Geen bestellijnen gevonden voor de geselecteerde periode
                </div>
            );
        }

        return (
            <Table
                columns={getColumns()}
                dataSource={safeVoorstellen}
                rowKey={(record, index) => record._id || `new-${index}`}
                expandable={{
                    expandedRowRender: (record) => (
                        expandRow(Array.isArray(record.bestellijnen) ? record.bestellijnen : [])
                    ),
                    rowExpandable: (record) => !selectedLeverancier?.gesplitsteBestelling && 
                                              Array.isArray(record.bestellijnen) &&
                                              record.bestellijnen.length > 0
                }}
                pagination={false}
                scroll={{ y: 0.5 * window.innerHeight }}
            />
        );
    };

    return (
        <div className="Screen-container">
            <h1 className='title'>Controle Bestelling</h1>
            
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8}>
                    <Select
                        style={{ width: '100%' }}
                        placeholder="Selecteer leverancier"
                        onChange={(value) => {
                            const selectedLeverancier = leveranciers.find(lev => lev._id === value);
                            handleLeverancierChange(selectedLeverancier);
                        }}
                        value={selectedLeverancier?._id}
                    >
                        {leveranciers.map(lev => (
                            <Option key={lev._id} value={lev._id}>
                                {lev.naam}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col span={8}>
                <DatePicker.RangePicker 
                    value={[startDatum, eindDatum]}
                    onChange={(dates) => {
                        if (dates) {
                            setStartDatum(dates[0]);
                            setEindDatum(dates[1]);
                        } else {
                            // Handle the case when dates are cleared
                            setStartDatum(null);
                            setEindDatum(null);
                        }
                    }}
                    format="DD/MM/YYYY"
                />
                </Col>
                <Col span={8}>
                    <Space>
                        <Button 
                            type='primary'
                            onClick={() => navigate('/Admin/Bestelling/extraProduct')} 
                            icon={<PlusOutlined />}
                            disabled={!selectedLeverancier}
                        >
                            Product Toevoegen
                        </Button>
                        <Button 
                            onClick={handleBestel} 
                            type="primary" 
                            disabled={voorstellen.length === 0}
                        >
                            Bestellen
                        </Button>
                    </Space>
                </Col>
            </Row>

            {renderContent()}
        </div>
    );
}
const expandRow = (data) => {
    // Ensure data is always an array
    const safeData = Array.isArray(data) ? data : [];
    
    if (safeData.length === 0) {
        return (
            <Empty 
                description="Geen detailgegevens beschikbaar" 
                image={Empty.PRESENTED_IMAGE_SIMPLE} 
                className="controleBestelling-empty-data"
            />
        );
    }
    
    // Define the columns for the nested table
    const columns = [
        {
            title: 'Klas',
            dataIndex: ['klas', 'naam'],
            key: 'klas',
            render: (text) => text || 'Niet gespecificeerd'
        },
        {
            title: 'Aantal',
            key: 'aantal',
            render: (_, record) => `${record.aantal} ${record.eenheid?.naam || ''}`
        },
        {
            title: 'Datum',
            dataIndex: 'kookDatum',
            key: 'kookDatum',
            render: (text) => text ? dayjs(text).format('DD-MM-YYYY') : 'Niet gespecificeerd'
        },
        {
            title: 'Leerkracht',
            dataIndex: ['leerkracht', 'naam'],
            key: 'leerkracht',
            render: (text) => text || 'Niet gespecificeerd'
        }
    ];
    
    return (
        <div className="controleBestelling-expanded-content">
            <div className="controleBestelling-details-header">
                <Row>
                    <Col>
                        <Typography.Title level={5} style={{ margin: 0 }}>
                            Bestelling Details
                        </Typography.Title>
                    </Col>
                </Row>
            </div>
            
            <Table
                columns={columns}
                dataSource={safeData}
                rowKey={(record, index) => record._id || `detail-${index}`}
                pagination={false}
                size="small"
                bordered
                className="controleBestelling-nested-table"
            />
        </div>
    );
};

export default ControleBestellingScreen;